import { render, staticRenderFns } from "./wifi.vue?vue&type=template&id=566bd28c&scoped=true"
var script = {}
import style0 from "./wifi.vue?vue&type=style&index=0&id=566bd28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566bd28c",
  null
  
)

export default component.exports